const initialState = {
    salutationPermissions:{},
    salutationLists: [],
    salutationStatus: [],
    changedSalutationStatus : [],
    loadingSalutation: false,
    errorsSalutation: {}
}

const  salutationReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_SALUTATION_PENDING":
        case "UPDATE_SALUTATION_PENDING":
            return { ...state, loadingSalutation: true, errorsSalutation: {} };

        case "GET_SALUTATION_LIST_PENDING":
        case "UPDATE_SALUTATION_STATUS_PENDING":
        case "DELETE_SALUTATION_PENDING":
        case "GET_SALUTATION_LIST_BY_ID_PENDING":
            return { ...state, loadingSalutation: true };

        case "GET_SALUTATION_LIST_FULFILLED":
            return {
                ...state,
                loadingSalutation: false,
                salutationLists: action.payload,
                salutationCount: action.salutationCount,
                salutationPermissions:action.permissions,
            };

        case "ADD_SALUTATION_FULFILLED":
            return {
                ...state,
                loadingSalutation: false,
                changedSalutationStatus: action.payload,
            };

        case "UPDATE_SALUTATION_FULFILLED":
            return {
                ...state,
                loadingSalutation: false,
                changedSalutationStatus: action.payload,
            };

        case "UPDATE_SALUTATION_STATUS_FULFILLED":
            return {
                ...state,
                loadingSalutation: false,
                changedSalutationStatus: action.payload,
            };

        case "GET_SALUTATION_LIST_BY_ID_FULFILLED":
            return {
                ...state,
                loadingSalutation: false,
                salutationLists: action.payload
            };

        case "DELETE_SALUTATION_FULFILLED":
            return {
                ...state,
                loadingSalutation: false,
                changedSalutationStatus: action.payload
            };

        case "RESET_SALUTATION_ERRORS":
            return {
                ...state,
                errorsSalutation: {},
            };

        case "RESET_SALUTATION_STATUS":
        case "RESET_DELETE_SALUTATION_STATUS":
            return {
                ...state,
                loadingSalutation: false,
                changedSalutationStatus: [],
                errorsSalutation: {},
            };

        case "GET_SALUTATION_LIST_REJECTED":
        case "ADD_SALUTATION_REJECTED":
        case "UPDATE_SALUTATION_REJECTED":
        case "UPDATE_SALUTATION_STATUS_REJECTED":
        case "DELETE_SALUTATION_REJECTED":
        case "GET_SALUTATION_LIST_BY_ID_REJECTED":
            return {
                ...state,
                loadingSalutation: false,
                errorsSalutation: action.payload
            };

        default:
            return state;
    }
}

export default salutationReducer;